import { Component } from '@angular/core';

@Component({
  selector: 'a18-accordion',
  templateUrl: './a18-accordion.component.html',
  styleUrl: './a18-accordion.component.scss'
})
export class A18AccordionComponent {

}
